import React from "react";
import { IconProps } from "./IconProps";

const File: React.FC<IconProps> = ({
    size = 22,
    color = "#F7F9F9",
    ...props
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 25"
            fill="none"
            {...props}
        >
            <path
                d="M14 2.59973V6.73027C14 7.29032 14 7.57035 14.109 7.78426C14.2049 7.97242 14.3578 8.1254 14.546 8.22128C14.7599 8.33027 15.0399 8.33027 15.6 8.33027H19.7305M8 15.3302V18.3302M16 13.3302V18.3302M12 10.8302V18.3302M20 10.3184V17.5302C20 19.2104 20 20.0504 19.673 20.6922C19.3854 21.2567 18.9265 21.7156 18.362 22.0032C17.7202 22.3302 16.8802 22.3302 15.2 22.3302H8.8C7.11984 22.3302 6.27976 22.3302 5.63803 22.0032C5.07354 21.7156 4.6146 21.2567 4.32698 20.6922C4 20.0504 4 19.2104 4 17.5302V7.1302C4 5.45004 4 4.60996 4.32698 3.96823C4.6146 3.40374 5.07354 2.9448 5.63803 2.65718C6.27976 2.3302 7.11984 2.3302 8.8 2.3302H12.0118C12.7455 2.3302 13.1124 2.3302 13.4577 2.41309C13.7638 2.48658 14.0564 2.60779 14.3249 2.77228C14.6276 2.95781 14.887 3.21723 15.4059 3.73609L18.5941 6.92431C19.113 7.44317 19.3724 7.7026 19.5579 8.00535C19.7224 8.27376 19.8436 8.5664 19.9171 8.8725C20 9.21777 20 9.58465 20 10.3184Z"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default File;
